import {
  SearchResultsListViewItemChildren,
  SearchResultsListViewItemChildrenProps,
} from "@coworker/apprestructured/src/scan-and-search/components/searchResults/SearchResultsListViewItem/SearchResultsListViewItemChildren";
import { SearchItemCardRenderType } from "@coworker/apprestructured/src/scan-and-search/types/SearchItemCardRenderType";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import FixaLink from "@coworker/apprestructured/src/shared/wrappers/FixaLink/FixaLink";
import { useParams } from "react-router";
import { useAllTaskTypes } from "@coworker/apprestructured/src/task-management/services/useTaskTypes";
import { TaskTypeNames } from "@coworker/apprestructured/src/task-management/constants/TaskTypeNames";
import styles from "./search-results-list-view-item.module.css";

interface SearchResultsListViewItemProps extends Pick<
  SearchResultsListViewItemChildrenProps,
  "item" | "itemStock"
> {
  itemCardRenderType?: SearchItemCardRenderType;
  handleItemCardClick?: (product: Item) => void;
  multiSelect?: boolean;
  isSelected?: boolean;
  onToggleItemSelect?: (item: Item) => void;
}

export const SearchResultsListViewItem = ({
  item,
  itemStock,
  handleItemCardClick,
  itemCardRenderType = SearchItemCardRenderType.link,
  multiSelect = false,
  isSelected = false,
  onToggleItemSelect,
}: SearchResultsListViewItemProps) => {
  const { type } = useParams<{ type: string }>();
  const isGlobalSearch = type === "global";
  const { data: taskTypes } = useAllTaskTypes();

  let navigationUrl;
  if (isGlobalSearch) {
    navigationUrl = `/product/${item.type}${item.no}`;
  } else if (type === "product_quality") {
    const productQualityId = taskTypes?.find(
      ({ name }) => name === TaskTypeNames.PRODUCT_QUALITY
    )?.id;
    const initialValues = JSON.stringify({
      details: { item: { no: item.no, type: item.type } },
    });
    navigationUrl = productQualityId
      ? `?taskCreator=${productQualityId}&initialValues=${encodeURIComponent(
          initialValues
        )}`
      : `/product/${item.type}${item.no}`;
  } else {
    navigationUrl = `/task/new/${type}`;
  }

  const isLocalCombination = item.type === "SCI";

  if (itemCardRenderType === "button" && multiSelect) {
    return (
      <div
        className={styles["list-item-root-multi-select"] || ""}
        onClick={() => onToggleItemSelect?.(item)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onToggleItemSelect?.(item);
          }
        }}
        data-testid="search-results-list-view-item"
        role="button"
        tabIndex={0}
      >
        <SearchResultsListViewItemChildren
          item={item}
          isLocalCombination={isLocalCombination}
          itemStock={itemStock}
        />
        <div
          className={styles["list-item-checkbox"] || ""}
          onClick={(e) => e.stopPropagation()}
        >
          <FixaCheckbox
            id={`search-result-select-${item.no}`}
            value={item.no}
            checked={isSelected}
            onChange={() => onToggleItemSelect?.(item)}
          />
        </div>
      </div>
    );
  }

  return itemCardRenderType === "button" ? (
    <div
      className={styles["list-item-root"] || ""}
      onClick={() => {
        handleItemCardClick?.(item);
      }}
      data-testid="search-results-list-view-item"
      role={"button"}
    >
      <SearchResultsListViewItemChildren
        item={item}
        itemStock={itemStock}
        isLocalCombination={isLocalCombination}
      />
    </div>
  ) : (
    <FixaLink
      to={navigationUrl}
      state={{
        fromSearch: true,
        product: {
          supplierNumber: "",
          product: item.no,
          type: "ART",
        },
      }}
      className={styles["list-item-root"] || ""}
      data-testid="search-results-list-view-item"
    >
      <SearchResultsListViewItemChildren
        item={item}
        itemStock={itemStock}
        isLocalCombination={isLocalCombination}
      />
    </FixaLink>
  );
};
